export enum FavoriteType {
    Workspace = 1,
    Document = 2,
    Folder = 3
}